<template>
  <div class="SIDEBAR">
    <fire-toast v-if="$device.isMobile" />
    <div class="SEARCH-AND-LEAD d-flex flex-0-0 p-x-2 bd-b-gray30">
      <div class="SEARCH">
        <job-search-box
            @input-focus="onSearchFocus"
            @input-blur="onSearchBlur" />
      </div>
      <div class="LEAD">
        <input
            type="button"
            value="Cancel"
            class="btn btn-sm btn-tertiary m-l-2 BUTTON"
            v-if="showCancel || customJobsQuery"
            @click="onClearSearch()">
        <leads-pause
            v-else
            id="sidebarLeadsPause"
            class="m-l-3"
            @change="onActiveOpen"
            @pause="onLeadsPause"/>
      </div>
    </div>
    <transition name="VERTICAL" mode="out-in">
      <top-navigation v-if="isSearchStatusAlias" />
      <div v-else class="d-flex flex-0-0 fd-column">
        <div class="PENDO" id="pendo"></div>
        <job-tabs />
        <top-navigation v-if="isPastStatusAlias" />
        <potential-top-navigation v-if="isPotentialStatusAlias" :key="topPotentialKey" />
      </div>
    </transition>
    <job-list @change="onJoblistChange" :key="topPotentialKey"/>
    <availability-modal v-if="isAvailabilityModalOpen" @close="onAvailabilityModalClose" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import jobParams from '@/mixins/job-params';
import AvailabilityModal from '@/views/Dashboard/components/AvailabilityModal';

import JobSearchBox from '@/components/JobSearchBox';
import JobList from '@/components/JobList';
import TopNavigation from './components/TopNavigation';
import PotentialTopNavigation from './components/PotentialTopNavigation';
import LeadsPause from './components/LeadsPause';
import JobTabs from './components/JobTabs';

export default {
  name: 'dashboard-sidebar',
  components: {
    TopNavigation,
    LeadsPause,
    AvailabilityModal,
    JobTabs,
    JobList,
    JobSearchBox,
    PotentialTopNavigation,
  },
  mixins: [
    jobParams,
  ],
  data () {
    return {
      isAvailabilityModalOpen: false,
      showCancel: false,
      topPotentialKey: 0,
    };
  },
  mounted () {
    this.fetch();
  },
  methods: {
    ...mapActions('account/pro', [
      'fetch',
    ]),
    onLeadsPause () {
      this.isAvailabilityModalOpen = true;
    },
    onAvailabilityModalClose () {
      this.isAvailabilityModalOpen = false;
    },
    onActiveOpen () {
      this.isActiveModalOpen = true;
    },
    onActiveModalClose () {
      this.isActiveModalOpen = false;
    },
    onClearSearch () {
      this.$emit('reset-job-search');
      this.showCancel = false;
    },
    onSearchFocus () {
      this.showCancel = true;
    },
    onSearchBlur (evt) {
      if (!evt) {
        this.showCancel = false;
      }
    },
    onJoblistChange () {
      this.topPotentialKey += 1;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  @import "~@/views/Dashboard/constants";

  .SEARCH-AND-LEAD {
    padding: 1*$unit 1*$unit;
    .SEARCH {
      flex: auto;
    }
    .LEAD {
      display: flex;
      flex: initial;
    }
    .BUTTON {
      border-color: #fff;
    }
  }
  .SIDEBAR {
    @include responsive(width, 100%, 320px, 450px);
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    border-left: 1px solid $color-gray30;
    border-right: 1px solid $color-gray30;
    background-color: white;
  }

  .VERTICAL-enter-active,
  .VERTICAL-leave-active {
    opacity: 1;
    transform: none;
    will-change: transform, opacity;
    transition: transform $transition-half-duration,
      opacity $transition-half-duration;

    &.VERTICAL-enter,
    &.VERTICAL-leave-to {
      opacity: 0;
      transform: translateY(-100%);
    }
  }
  .PENDO {
    min-height: 5px;
  }
</style>
